module.exports = __webpack_public_path__ + "static/media/sports-icon.d675ade9.svg";